import { Registry } from '../registry';
import { mapImages } from './images';

export const registry = new Registry(mapImages);
